// extracted by mini-css-extract-plugin
export default {"label":"styles_label__fpIPu","checkbox":"styles_checkbox__or6z0"};